import {createGroupFilterVar, useDomainIDParam} from "@/types";
import {HasPermission, Link} from "../widgets";
import {PickupGroupListFragment, PickupGroupListFragmentDoc} from "./queries.generated";
import {GroupFilterType} from "@/api";
import {GenericTable} from "@dvrt/graphql-widgets";
import DeletePickupGroupButton from "./DeletePickupGroupButton";
import {useConcertoGenericQuery, useDomainNameQuery} from "@/hooks";
import CreateButton from "./create/CreateButton";
import {Box} from "@mui/material";
import {defineMessages} from "react-intl";
import {commonTranslations} from "@/utils/translations";
import {ContextFilters} from "@/context/AuthProvider";

const PickupGroupList = () => {
    const domainId = useDomainIDParam();

    const query = useConcertoGenericQuery<PickupGroupListFragment>("groups", PickupGroupListFragmentDoc, {
        filtering: {
            argumentName: "filter",
            placeHolder: commonTranslations.filterPlaceholders.name,
            idPrefix: "search-pickup-groups",
        },
        fetchPolicy: "cache-and-network",
        extraVariables: {
            domainId: domainId,
            type: createGroupFilterVar(GroupFilterType.Pickup),
        },
        initialOrdering: ["name"],
    });

    const {domainName} = useDomainNameQuery(domainId);

    return (
        <Box sx={{paddingX: 3}}>
            <GenericTable<PickupGroupListFragment>
                query={query}
                labels={defineMessages({
                    name: {id: "name", defaultMessage: "Name"},
                })}
                dataRenderers={{
                    name: (value, row) => {
                        return <Link to={`/domains/${domainId}/pickup-groups/${row.id}/settings`}>{value}</Link>;
                    },
                }}
                extraColumns={[
                    {
                        path: "actions",
                        label: null,
                        renderer: (row) => {
                            return (
                                <DeletePickupGroupButton
                                    name={row.name}
                                    id={row.id}
                                    onSuccess={() => query.refetch()}
                                />
                            );
                        },
                    },
                ]}
                createButton={
                    <HasPermission name="add_call_group" contextFilter={ContextFilters.domain(domainName)}>
                        <CreateButton domainId={domainId} onSuccess={() => query.refetch()} />
                    </HasPermission>
                }
                orderableFields="all"
            />
        </Box>
    );
};

export default PickupGroupList;
